// Fetch helper function
import fetch from 'helpers/Fetch';

// Import API path/routes constant
import { URL_CUSTOMER_MAP } from 'constants/api';

const fetchCustomerMapData = payload => {
  return fetch({
    url: URL_CUSTOMER_MAP,
    data: payload,
  });
};

export { fetchCustomerMapData };
